import { IconButton, Tooltip } from '@chakra-ui/react';
import React, { useState } from 'react';
import { IoDuplicate } from 'react-icons/io5';
import * as ga from '../../../canopy-ui-components/google-analytics';
import { useCurrentColors } from '../../../canopy-ui-components/hooks/UseCurrentColors/UseCurrentColors';
import CopyAndCreateModal from './CopyAndCreateModal';

interface Props extends PageComponentProps<any> {
    userId: number[];
    data: any[];
    globalProps: GlobalProps;
    refreshData: () => void;
}

export function CopyAndCreateAction(props: any) {
    const currentColors = useCurrentColors();
    const [showModal, setShowModal] = useState(false);
    const {
        globalProps: { t },
    } = props;

    const handleClick = async () => {
        ga.event({
            action: `${window.location.pathname.replace(
                '//g/',
                ''
            )} > Clicked Copy Mapping`,
        });
        setShowModal(true);
    };

    const mapping = React.useMemo(() => {
        return props?.data?.map((data: any) => ({
            userDetails: {
                userId: data?.userId,
                userRoleId: data?.userRoleId,
                adminId: data?.adminId,
                adminRoleId: data?.adminRoleId,
                userName: data?.username,
                paOrRmName: data?.adminUsername,
                deviceType: data?.device,
            },
            workbookDetails: data?.submenuWorkbook?.map((workbook: any) => ({
                subMenuKey: workbook.submenuKey,
                workbookPath: workbook.workbookViewPath,
            })),
        }));
    }, [props?.data]);

    return (
        <>
            <Tooltip
                aria-label="copy-mapping"
                label={t('ui.mm.tooltip.copy-mapping')}
                placement="bottom-start"
                hasArrow>
                <IconButton
                    background="transparent"
                    cursor="pointer"
                    border="none"
                    width="20px !important"
                    minWidth="20px !important"
                    height="20px !important"
                    icon={<IoDuplicate />}
                    aria-label="copy-mapping"
                    data-test="copy-mapping"
                    backgroundColor="transparent"
                    color={currentColors.brand['300']}
                    variant="ghost"
                    _hover={{
                        backgroundColor: 'transparent',
                    }}
                    _focus={{
                        border: '0px',
                        backgroundColor: 'transparent',
                        outline: 'none',
                    }}
                    _active={{
                        border: '0px',
                    }}
                    onClick={handleClick}></IconButton>
            </Tooltip>
            {showModal && (
                <CopyAndCreateModal
                    mapping={mapping}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    {...props}
                />
            )}
        </>
    );
}

export default CopyAndCreateAction;
